import type { NavigateFunction } from 'react-router-dom';
import routes from 'routes';
import {
  markSkipPwaHomeRestore,
  setPwaLastEntity,
} from 'utils/pwa-last-entity';
import { buildPwaEntityTaxReturnsNavigateUrl } from 'utils/pwa-nav';

/**
 * In-report PWA back. `organisationId` opens that entity's Returns tab and
 * remembers it. Without an id, Home is explicit and must not restore the report.
 */
export function handlePwaReturnBack(
  organisationId: string | undefined,
  navigate: NavigateFunction
): void {
  if (!organisationId) {
    markSkipPwaHomeRestore();
    navigate(routes.main, { state: { pwaExplicitHome: true } });
    return;
  }
  const returnsUrl = buildPwaEntityTaxReturnsNavigateUrl(organisationId);
  setPwaLastEntity(organisationId, 'vat', returnsUrl.split('?')[0]);
  navigate(returnsUrl);
}
